import React from 'react'
import Header from "../../components/header/index";
import ContactUsContent from './contactContent/contactusContent';
import Footer from "../../components/footer";

const contactUs = () => {
  return (
    <div className="main">
    <Header />
    <ContactUsContent /> 
    <Footer />
    </div>
  )
}

export default contactUs